let i_ = 0;
export const GAME_MODE = Object.freeze({
  CLASSIC: i_++,
  STORY: i_++,
  EDITOR: i_++,
  COMMUNITY: i_++,
  SKIN_DEMO: i_++,
  UNSET: i_++,
});
export const GAME_MODE_INV = Object.freeze(
  Object.keys(GAME_MODE).reduce((acc, key) => {
    acc[GAME_MODE[key]] = key;
    return acc;
  }, {})
);

class GameState {
  #locked;

  constructor() {
    this.reset();
  }

  reset() {
    this.cells = [];
    this.mode = GAME_MODE.UNSET;
    this.cats = null;
    this.showTip = false;
    this.#locked = false;
  }

  fromOther(other) {
    this.cells = other.cells;
    this.mode = other.mode;
    this.cats = other.cats;
    this.showTip = other.showTip;
    this.#locked = other.#locked;
  }

  isLocked() {
    return this.#locked;
  }

  lock() {
    this.#locked = true;
  }

  unlock() {
    this.#locked = false;
  }

  copy() {
    const copy = new GameState();
    copy.cells = [...Array(this.cells.length)].map((_, i) =>
      [...Array(this.cells[i].length)].map((_, j) => this.cells[i][j])
    );
    copy.mode = this.mode;
    copy.cats = this.cats.copy();
    copy.showTip = this.showTip;
    copy.#locked = this.#locked;
    return copy;
  }
}

class GameEditorState {
  constructor() {
    this.reset();
  }

  reset() {
    this.editing = false;
    this.selectionModeMultiple = false;
    this.showLoosingFields = false;
  }

  fromOther(other) {
    this.editing = other.editing;
    this.selectionModeMultiple = other.selectionModeMultiple;
    this.showLoosingFields = other.showLoosingFields;
  }
}

class LevelDefinition {
  constructor() {
    this.reset();
  }

  reset() {
    this.fieldGeometries = null;
    this.placements = null;
    this.catPlacement = null;
    this.helper = {};
    this.timeLimit = null;
    this.stepsLimit = null;
    this.fieldSize = null;
    this.innerFieldSize = null;
    this.info = null;
    this.helperCoords = null;
    this.metadata = {};
  }

  fromOther(other) {
    this.fieldGeometries = other.fieldGeometries;
    this.placements = other.placements;
    this.catPlacement = other.catPlacement;
    this.helper = other.helper;
    this.timeLimit = other.timeLimit;
    this.stepsLimit = other.stepsLimit;
    this.fieldSize = other.fieldSize;
    this.innerFieldSize = other.innerFieldSize;
    this.info = other.info;
    this.helperCoords = other.helperCoords;
    this.metadata = other.metadata;
  }

  copy() {
    const copy = new LevelDefinition();
    const deepCopy = JSON.parse(JSON.stringify(this));
    copy.fieldGeometries = deepCopy.fieldGeometries;
    copy.placements = deepCopy.placements;
    copy.catPlacement = deepCopy.catPlacement;
    copy.helper = deepCopy.helper;
    copy.timeLimit = deepCopy.timeLimit;
    copy.stepsLimit = deepCopy.stepsLimit;
    copy.fieldSize = deepCopy.fieldSize;
    copy.innerFieldSize = deepCopy.innerFieldSize;
    copy.info = deepCopy.info;
    copy.helperCoords = deepCopy.helperCoords;
    copy.metadata = deepCopy.metadata;
    return copy;
  }
}

export const levelDef = new LevelDefinition();
export const gameState = new GameState();
export const gameEditorState = new GameEditorState();

if (__DEV__) {
  window.gameState = gameState;
  window.gameEditorState = gameEditorState;
  window.levelDef = levelDef;
}
